<template>
  <div class="div_input_mobile flex" :class="worring ? 'input_worring' : ''">
    <span>+86</span>
    <i></i>
    <el-input
      v-model="mobile"
      @focus="worring = false"
      size="large"
      maxlength="11"
      class="key_number"
      :controls="false"
      @input="inputPhone"
      placeholder="请输入手机号"
    />
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted, defineExpose } from "vue";

const props = defineProps(["modelValue"]);
const emit = defineEmits(["update:modelValue"]);

let mobile = ref("");
let worring = ref(false);

onMounted(() => {
  mobile.value = props.modelValue;
});

function inputPhone(value) {
  mobile.value = value;
  emit("update:modelValue", mobile.value);
}

defineExpose({
  worring,
});
</script>

<style lang='scss' scoped>
.div_input_mobile {
  height: 60px;
  background: #f6f6f7;
  border-radius: 16px;
  padding: 0px 24px;
  border: 1px solid transparent;
  box-sizing: border-box;
  overflow: hidden;
  user-select: none;
  transition: all $anim-time-fn-ease-out 0.25s;

  > span {
    font-size: 16px;
    font-weight: 600;
    color: #1f2328;
  }

  > i {
    display: inline-block;
    width: 1px;
    height: 23px;
    background-color: #d0d3d6;
    margin: 0px 16px;
  }
}

.key_number {
  height: 60px;

  :deep(.el-input__wrapper) {
    padding: 0px;
    box-shadow: none;
    background-color: transparent;
    input {
      height: 60px;
      font-size: 16px;
    }
  }
}

.input_worring {
  border: 1px solid #f56c6c;
}
@media screen and (max-width: 768px) {
  .div_input_mobile {
    height: 0.6rem;
    border-radius: 0.1rem;
    padding: 0px 0.2rem;
    border: 1px solid transparent;
    > span {
      font-size: 0.16rem;
    }

    > i {
      width: 1px;
      height: 0.2rem;
      margin: 0px 0.14rem;
    }
  }
  .key_number {
    height: 0.6rem;
    :deep(.el-input__wrapper) {
      padding: 0px;
      box-shadow: none;
      background-color: transparent;
      input {
        height: 0.6rem;
        font-size: 0.16rem;
      }
    }
  }

  .input_worring {
    border: 1px solid #f56c6c;
  }
}
</style>
